<template>
    <v-container fill-height fluid grid-list-xl class="pt-0">
        <v-layout wrap>
            <v-flex xs12 class="pt-0">
                <material-card color="green" title="Wercberger Hotline Calls">
                    <v-data-table
                        :headers="headers"
                        :items="callDetails"
                        v-bind:pagination.sync="pagination"
                        hide-actions
                        disable-initial-sort
                    >
                        <template slot="headerCell" slot-scope="{ header }">
                            <span
                                class="font-weight-light text-success text--darken-3"
                                v-text="header.text"
                            />
                        </template>
                        <template slot="items" slot-scope="{ index, item }">
                            <tr
                                @click="viewDetails(item)"
                                style="cursor: pointer;"
                            >
                                <td>
                                    <v-tooltip top dark>
                                        <template #activator="{ on }" dark>
                                            <v-icon
                                                v-on="on"
                                                dark
                                                :color="
                                                    getStatusIcon(item).color
                                                "
                                                >{{
                                                    getStatusIcon(item).icon
                                                }}</v-icon
                                            >
                                        </template>
                                        <span dark>{{ item.Status }}</span>
                                    </v-tooltip>
                                </td>
                                <td class="font-weight-regular">
                                    {{ getCallName(item) }}
                                </td>
                                <td class="text-xs-left font-weight-regular">
                                    {{ item.CallerID }}
                                </td>
                                <td class="text-xs-left font-weight-regular">
                                    {{ formatTime(item.Timestamp) }}
                                </td>
                                <td class="text-xs-left font-weight-regular">
                                    {{ getCallDuration(item) }}
                                </td>
                            </tr>
                        </template>
                    </v-data-table>
                    <div class="text-xs-center mt-2">
                        <v-pagination
                            v-model="pagination.page"
                            :length="pages"
                            :total-visible="5"
                        ></v-pagination>
                    </div>
                </material-card>
            </v-flex>
        </v-layout>
        <v-dialog v-model="viewCallDialog" max-width="750">
            <v-card class="p-2">
                <v-card-title class="headline">Call Activity</v-card-title>
                <v-card-text class="mb-3">
                    <v-layout row>
                        <div>
                            <div class="font-weight-medium mb-2">
                                {{
                                    getCallName(clickedCall)
                                        ? getCallName(clickedCall) +
                                          " - " +
                                          clickedCall.CallerID
                                        : clickedCall.CallerID
                                }}
                            </div>
                        </div>
                        <v-spacer></v-spacer>
                        <div>
                            <v-layout row class="mb-2">
                                <div class="font-weight-medium mr-2">
                                    Call Time:
                                </div>
                                <div>
                                    {{ formatTime(clickedCall.Timestamp) }}
                                </div>
                            </v-layout>
                        </div>
                    </v-layout>
                </v-card-text>
                <v-list>
                    <div v-for="(action, index) in clickedCall.Logs">
                        <v-list-tile
                            class="row-height"
                            v-bind:class="{
                                'mt-3': action.RecordingURL,
                                'mb-4': action.RecordingURL,
                            }"
                        >
                            <v-list-tile-content>
                                <v-list-tile-title>{{
                                    formatTime(action.Timestamp)
                                }}</v-list-tile-title>
                            </v-list-tile-content>
                            <v-spacer></v-spacer>
                            <v-list-tile-action style="height: 90px;">
                                <v-list-tile-title
                                    class="text-xs-right mt-1"
                                    v-bind:class="{
                                        'pt-3 pb-4': !action.RecordingURL,
                                    }"
                                    >{{ action.Description }}
                                </v-list-tile-title>
                                <audio
                                    style="height: 33px;"
                                    v-if="action.RecordingURL"
                                    class="mt-2"
                                    controls
                                    :src="action.RecordingURL"
                                    ref="recording"
                                ></audio>
                                <div class="progress mt-2">
                                    <span
                                        id="progress-amount"
                                        v-if="action.RecordingURL"
                                        ref="recordingProgress"
                                    ></span>
                                </div>
                            </v-list-tile-action>
                        </v-list-tile>
                        <div v-if="action.Data" class="body-2 ml-3 mb-2">
                            {{ action.Data }}
                        </div>
                        <v-divider
                            v-if="index + 1 < clickedCall.Logs.length"
                        ></v-divider>
                    </div>
                </v-list>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                        class="mb-2"
                        @click="viewCallDialog = false"
                        color="#999"
                        dark
                        >Close</v-btn
                    >
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-container>
</template>

<script>
import ky from "ky";
import * as firebase from "firebase/app";
import "firebase/database";
import moment from "moment";

export default {
    data() {
        return {
            rowsPerPageItems: [10, 20],
            pagination: {
                totalItems: 0,
                rowsPerPage: 20,
                page: 1,
            },

            headers: [
                { value: "Status", text: "Status" },
                { value: "Name", text: "Caller" },
                { value: "CallerID", text: "Caller ID" },
                { value: "Timestamp", text: "Time" },
                { value: "duration", text: "Duration" },
                // { value: "HangupCauseName", text: "Hangup Cause" }
            ],

            calls: [],
            callDetails: [],

            clickedCall: "",
            viewCallDialog: false,

            contacts: [],
        };
    },
    computed: {
        pages() {
            return this.pagination.rowsPerPage
                ? Math.ceil(
                      this.pagination.totalItems / this.pagination.rowsPerPage,
                  )
                : 0;
        },
    },
    filters: {
        pretty: function(value) {
            if (!value) return "";

            return JSON.stringify(value, null, 2);
        },
    },
    created() {
        this.loadData();
        this.firebaseSetup();
        this.loadContacts();
    },
    mounted() {
        //this.intervalID = window.setInterval(this.loadLastCalls, 60000);
    },
    beforeDestroy() {
        //window.clearInterval(this.intervalID);
    },
    methods: {
        // async loadLastCalls() {
        //     const calls = await ky("api/home/getLastCalls", {
        //         prefixUrl: this.getDomain()
        //     }).json();

        //     calls.forEach(c => this.calls.push(c));

        //     this.callDetails.forEach(cd => {
        //         const call = this.calls.find(c => c.callUUID == cd.Call_UUID);
        //         if (call) {
        //             cd.duration = call.callDuration;
        //         }
        //     });
        // },
        async loadData() {},
        firebaseSetup() {
            const user = this.$store.state.user;

            //if (!["joel", "saul"].includes(user)) return;

            const firebaseConfig = {
                apiKey: "Xs6kU5UjjL8n5LdLQJMGnWcaEietBLrj5U9FnpIb",
                authDomain: "broadcast-b7a56.firebaseapp.com",
                databaseURL: "https://broadcast-b7a56.firebaseio.com",
                projectId: "broadcast-b7a56",
            };

            // Initialize Firebase
            if (!firebase.apps.length) {
                firebase.initializeApp(firebaseConfig);
            }

            var database = firebase.database();
            var ref = firebase.database().ref("wercberger_hotline_calls");

            const callsRef = ref.orderByKey().limitToLast(1000);

            callsRef.on(
                "value",
                (snapshot) => {
                    const callDetails = Object.values(snapshot.val()).map(
                        (call) => {
                            call.duration = call.Duration;
                            call.CallerID = this.formatPhoneNumber(call.Name);

                            return call;
                        },
                    );
                    this.callDetails = callDetails.sort((a, b) => {
                        if (Date.parse(a.Timestamp) > Date.parse(b.Timestamp))
                            return -1;
                        if (Date.parse(a.Timestamp) < Date.parse(b.Timestamp))
                            return 1;
                        return 0;
                    });

                    this.pagination.totalItems = callDetails.length;
                },
                function(error) {
                    console.log("Error: " + error.code);
                },
            );
        },
        getCallDuration(item) {
            if (item.duration > 0)
                return moment("2015-01-01")
                    .startOf("day")
                    .seconds(item.duration)
                    .format("mm:ss");

            const endTime = item.Logs[item.Logs.length - 1].Timestamp;

            const duration = moment.duration(
                moment(endTime).diff(moment(item.Timestamp)),
            );

            return moment.utc(duration.as("milliseconds")).format("mm:ss");
        },
        getCallName(call) {
            if (!this.contacts) return;

            if (!call.Name) return;

            const contact = this.contacts.find((c) => {
                return c.phoneNumber == call.Name.substring(1);
            });

            if (!contact) return;

            return contact.firstName.replace("Phone", "")
                ? contact.firstName.replace("Phone", "") +
                      " " +
                      contact.lastName
                : contact.lastName;
        },
        getStatusIcon(item) {
            if (item.duration) {
                return {
                    icon: "mdi-check-circle",
                    color: "success",
                };
            }

            return {
                icon: "mdi-clock",
                color: "#fdb400",
            };
        },
        getDomain() {
            return window.location.origin.startsWith("http://localhost:8081") ||
                window.location.origin.startsWith("http://localhost:8080")
                ? "https://localhost:44337"
                : window.location.origin;
        },
        formatTime(date) {
            return moment(date).format("MM/DD/YYYY h:mm:ss A");
        },
        formatPhoneNumber(phoneNumberString) {
            if (phoneNumberString.length > 11) return phoneNumberString;

            const value = phoneNumberString.substring(1);
            var cleaned = ("" + value).replace(/\D/g, "");
            var match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);
            if (match) {
                return "(" + match[1] + ") " + match[2] + "-" + match[3];
            }
            return null;
        },
        getPlaybackSeconds(index) {
            const logs = this.clickedCall.Logs.filter((l) => l.RecordingURL);

            const event1 = logs[index];
            const originalIndex = this.clickedCall.Logs.indexOf(event1);

            let event2 = "";

            if (this.clickedCall.Logs.length == originalIndex + 1) {
                event2 = { Timestamp: this.clickedCall.EndTime };
            } else {
                event2 = logs[index + 1];
            }

            const duration = moment.duration(
                moment(event2.Timestamp).diff(moment(event1.Timestamp)),
            );

            return duration.asSeconds();
        },
        closeCallDetails() {
            this.viewCallDialog = false;
            this.clickedCall = "";
        },
        async loadContacts() {
            const response = await this.$http.get(
                "https://wercbergerproductions1-kha7mhdahq-ue.a.run.app/api/wercbergerHotline/getContacts",
            );

            this.contacts = response.data;
        },
        viewDetails(item) {
            item.EndTime = item.EndTime
                ? item.EndTime
                : item.Logs[item.Logs.length - 1].Timestamp;

            this.clickedCall = item;

            console.log(item);

            //console.log(JSON.stringify(this.clickedCall, null, 2));

            this.viewCallDialog = true;

            setTimeout(this.setPlaybackTime, 0);
        },
        setPlaybackTime() {
            this.clickedCall.Logs.filter((l) => l.RecordingURL).forEach(
                (log, index) => {
                    if (!this.$refs.recording || !this.$refs.recording[index])
                        return;

                    this.$refs.recording[
                        index
                    ].currentTime = this.getPlaybackSeconds(index);

                    this.addProgressEvent(this.$refs.recording[index], index);
                },
            );
        },
        addProgressEvent(myAudio, index) {
            myAudio.addEventListener("timeupdate", (e) =>
                this.updateProgress(e, index),
            );
        },
        updateProgress(e, index) {
            const duration = this.$refs.recording[index].duration;

            if (duration > 0) {
                this.$refs.recordingProgress[index].style.width =
                    (this.$refs.recording[index].currentTime / duration) * 100 +
                    "%";
            }
        },
    },
};
</script>
<style>
tbody tr:nth-child(even) {
    background-color: #eee;
}

.row-height.v-list__tile theme--light {
    min-height: 75px !important;
    height: 75px !important;
}
.progress {
    margin-top: -20px;
    height: 5px;
    position: relative;
    width: 300px;
}

#progress-amount {
    display: block;
    height: 100%;
    background-color: #5cb860;
    width: 0;
}
</style>
